









import { getUIConfig } from '@/lib/photograph-flow/flow/configSkin'
import { Component, Vue } from 'vue-property-decorator'
import { isMobile } from './lib/common-util'
import store from './store'
@Component
export default class App extends Vue {
  loadBtn: boolean = false
  originaLocale: any = ''

  // switch language pack
  initLocale() {
    const navigatorLanguageFlag = navigator.language ? navigator.language.split('-')[0] : 'en'
    const factoryLowerStr = navigatorLanguageFlag.toLowerCase()
    const locale = ['zh', 'en', 'vi', 'id', 'hi', 'th'].includes(factoryLowerStr) ? factoryLowerStr : 'en'

    this.setLocale(locale)
  }

  setLocale(locale: string) {
    this.$root.$i18n.locale = locale
    store.locale = locale
  }

  async isConfigCon(locale: any) {
    try {
      const data = await getUIConfig({
        locale: locale || 'en',
        token: this.$route.query.biz_token,
        signatureId: '',
      })
      if (data.code === 'SUCCESS' && data.data) {
        const resultSkinCon = data.data || {}
        // sessionStorage.setItem('UIConfigObj', JSON.stringify(resultSkinCon))
        Vue.prototype.$addStorageEvent(2, 'UIConfigObj', JSON.stringify(resultSkinCon))
      } else if (data.code === 'SUCCESS' && data.data === null) {
        const languageArr = ['zh', 'en', 'vi', 'id', 'hi', 'th']
        if (languageArr.includes(locale)) {
          this.setLocale(locale)
          Vue.prototype.$addStorageEvent(2, 'UIConfigObj', JSON.stringify({}))
        } else {
          this.initLocale()
          if (this.originaLocale !== this.$root.$i18n.locale) {
            this.originaLocale = this.$root.$i18n.locale
            this.isConfigCon(this.$root.$i18n.locale)
          } else {
            Vue.prototype.$addStorageEvent(2, 'UIConfigObj', JSON.stringify({}))
          }
        }
      } else {
        this.initLocale()
        Vue.prototype.$addStorageEvent(2, 'UIConfigObj', JSON.stringify({}))
        this.$router.replace({
          name: isMobile() ? 'ImageResultV2' : 'pcResult',
          query: {
            biz_token: this.$route.query.biz_token,
            result: data.code,
            message: data.message,
          },
        })

      }
    } catch (error) {
      console.log(error)
    } finally {
      this.loadBtn = true
    }
  }
  getQueryString(name: any) {
    let reg = `(^|&)${name}=([^&]*)(&|$)`
    let r = window.location.search.substr(1).match(reg)
    if (r != null) { return unescape(r[2]) }
    return null
  }
  created() {
    const language = this.getQueryString('language')
    if (language && language.length > 0) {
      this.setLocale(language)
    } else {
      // 获取浏览器语言
      this.initLocale()
    }
    this.originaLocale = this.$root.$i18n.locale
    this.isConfigCon(this.$root.$i18n.locale)
  }
}
